import { createPermission } from '@backstage/plugin-permission-common';

export const observabilityViewPermission = createPermission({
  name: 'observability.view',
  attributes: { action: 'read' },
});

export const observabilityPermissions = [observabilityViewPermission];
